import { match } from "ts-pattern";

import type {
  EndIncidentDestination,
  IncidentWorkItemId,
} from "@thalamos/vision-common";

import { createRoute } from "./createRoute.js";

/**
 * The page an ending takes the officer to. An ending without a page of its own,
 * the pre-triage dialog or none at all, goes to the incident's progress page.
 */
export function endIncidentRoute(
  incidentWorkItemId: IncidentWorkItemId,
  destination: EndIncidentDestination,
): string {
  return match(destination)
    .with("finishForm", () =>
      createRoute.incidentFinishFormPage(incidentWorkItemId),
    )
    .with("preEndIncident", () =>
      createRoute.incidentPreEndIncidentPage(incidentWorkItemId),
    )
    .with("preTriageDialog", "cannotEnd", () =>
      createRoute.incidentProgressPage(incidentWorkItemId),
    )
    .exhaustive();
}
